import { render, staticRenderFns } from "./FontSizeInput.vue?vue&type=template&id=7d00532c&scoped=true"
import script from "./FontSizeInput.vue?vue&type=script&lang=js"
export * from "./FontSizeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d00532c",
  null
  
)

export default component.exports